module.exports = __webpack_public_path__ + "img/About_item_1.6e40c486.jpg";